import React, { useState } from "react";
import {
  TextField,
  MenuItem,
  RadioGroup,
  FormControlLabel,
  Radio,
  Button,
} from "@mui/material";

const localGovts = [
  "Chikun",
  "Giwa",
  "Igabi",
  "Ikara",
  "Jaba",
  "Jema'a",
  "Kachia",
  "Kaduna North",
  "Kaduna South",
  "Kagarko",
  "Kajuru",
  "Kaura",
  "Kauru",
  "Kubau",
  "Kudan",
  "Lere",
  "Makarfi",
  "Sabon Gari",
  "Sanga",
  "Soba",
  "Zangon Kataf",
  "Zaria",
];

const institutions = [
  "Ahmadu Bello University",
  "Kaduna Polytechnic",
  "Nigerian Defence Academy",
  "Kaduna State University",
  "Federal College of Education Zaria",
];

const AwardComponent = () => {
  const [awardOption, setAwardOption] = useState("");
  const [batchOption, setBatchOption] = useState("existing");
  const [selectedBatch, setSelectedBatch] = useState("");
  const [selectedLocalGovt, setSelectedLocalGovt] = useState("");
  const [selectedInstitution, setSelectedInstitution] = useState("");

  const existingBatches = ["Batch 1", "Batch 2", "Batch 3"];

  const handleAward = () => {
    const newBatchName = batchOption === "new" ? `Batch ${existingBatches.length + 1}` : selectedBatch;
    if (batchOption === "existing" && !selectedBatch) {
      alert("Please select an existing batch.");
      return;
    }

    console.log({
      awardOption,
      batchOption,
      batchName: newBatchName,
      selectedLocalGovt,
      selectedInstitution,
    });
    alert("Awarded!");
  };

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <TextField
          fullWidth
          select
          label="Award Type"
          value={awardOption}
          onChange={(e) => setAwardOption(e.target.value)}
        >
          <MenuItem value="all">Award All</MenuItem>
          <MenuItem value="local-govt">Award by Local Government</MenuItem>
          <MenuItem value="institution">Award by Institution</MenuItem>
        </TextField>
      </div>

      {awardOption === "local-govt" && (
        <div style={{ marginBottom: 20 }}>
          <TextField
            fullWidth
            select
            label="Select Local Government"
            value={selectedLocalGovt}
            onChange={(e) => setSelectedLocalGovt(e.target.value)}
          >
            {localGovts.map((govt) => (
              <MenuItem key={govt} value={govt}>
                {govt}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}

      {awardOption === "institution" && (
        <div style={{ marginBottom: 20 }}>
          <TextField
            fullWidth
            select
            label="Select Institution"
            value={selectedInstitution}
            onChange={(e) => setSelectedInstitution(e.target.value)}
          >
            {institutions.map((institution) => (
              <MenuItem key={institution} value={institution}>
                {institution}
              </MenuItem>
            ))}
          </TextField>
        </div>
      )}

      <div style={{ marginBottom: 20 }}>
        <h3>Batch Options</h3>
        <RadioGroup
          value={batchOption}
          onChange={(e) => setBatchOption(e.target.value)}
        >
          <FormControlLabel
            value="existing"
            control={<Radio />}
            label="Add to Existing Batch"
          />
          <FormControlLabel
            value="new"
            control={<Radio />}
            label="Add to New Batch"
          />
        </RadioGroup>
        {batchOption === "existing" && (
          <TextField
            fullWidth
            select
            label="Select Batch"
            value={selectedBatch}
            onChange={(e) => setSelectedBatch(e.target.value)}
          >
            {existingBatches.map((batch) => (
              <MenuItem key={batch} value={batch}>
                {batch}
              </MenuItem>
            ))}
          </TextField>
        )}
      </div>
      <Button variant="contained" onClick={handleAward}>
        Confirm Award
      </Button>
    </div>
  );
};

export default AwardComponent;